"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeasure = void 0;
var react_1 = require("react");
var __1 = require("..");
/**
 * Uses ResizeObserver to track element dimensions and re-render component when they change.
 */
function useMeasure() {
    var elementRef = (0, react_1.useRef)(null);
    var _a = (0, __1.useSafeState)(), rect = _a[0], setRect = _a[1];
    var observerHandler = (0, __1.useRafCallback)(function (entry) {
        return setRect(entry.contentRect);
    })[0];
    (0, __1.useResizeObserver)(elementRef, observerHandler);
    return [rect, elementRef];
}
exports.useMeasure = useMeasure;
